
import { useState } from 'react';
import Layout from '../../components/feature/Layout';
import OperationsTable from './components/OperationsTable';
import OperationFilters from './components/OperationFilters';
import OperationDetail from './components/OperationDetail';

export default function Operations() {
  const [selectedOperation, setSelectedOperation] = useState<string | null>(null);
  const [showNewModal, setShowNewModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const showToast = (message: string) => {
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const handleUploadDocument = () => {
    setShowUploadModal(false);
    showToast('Documento subido exitosamente');
  };

  const handleUpdateStatus = () => {
    setShowStatusModal(false);
    showToast('Estado actualizado correctamente');
  };

  const handleCreateOperation = () => {
    setShowNewModal(false);
    showToast('Operación OP-2024-1848 creada exitosamente');
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Core Operativo Aduanero</h1>
            <p className="text-sm text-[#6B7280] mt-1">Gestión integral de operaciones de comercio exterior</p>
          </div>
          <button 
            onClick={() => setShowNewModal(true)}
            className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md font-medium hover:shadow-md transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-add-line mr-2"></i>Nueva Operación
          </button>
        </div>

        {/* Filters */}
        <OperationFilters />

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <OperationsTable onSelectOperation={setSelectedOperation} />
          </div>
          <div>
            <OperationDetail 
              operationId={selectedOperation} 
              onUploadDocument={() => setShowUploadModal(true)}
              onUpdateStatus={() => setShowStatusModal(true)}
            />
          </div>
        </div>
      </div>

      {/* Modal Nueva Operación */}
      {showNewModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Nueva Operación Aduanera</h2>
              <button onClick={() => setShowNewModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Operación *</label>
                  <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Importación</option>
                    <option>Exportación</option>
                    <option>Tránsito</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Cliente *</label>
                  <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Seleccionar cliente...</option>
                    <option>Importadora Global S.A.</option>
                    <option>Exportadora del Sur Ltda.</option>
                    <option>Comercial Andina S.A.C.</option>
                    <option>Distribuidora Pacífico E.I.R.L.</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Puerto/Aduana Origen *</label>
                  <input type="text" placeholder="Ej: Shanghai, China" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Puerto/Aduana Destino *</label>
                  <input type="text" placeholder="Ej: Callao, Perú" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Valor FOB *</label>
                  <input type="text" placeholder="$0.00 USD" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Incoterm</label>
                  <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>FOB</option>
                    <option>CIF</option>
                    <option>EXW</option>
                    <option>DDP</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">ETA Estimado</label>
                  <input type="date" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Descripción de Mercancía</label>
                <textarea rows={3} placeholder="Descripción detallada de la mercancía..." className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Fracción Arancelaria</label>
                <input type="text" placeholder="Ej: 8471.30.01" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowNewModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button onClick={handleCreateOperation} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                Crear Operación
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Subir Documento */}
      {showUploadModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Subir Documento</h2>
              <button onClick={() => setShowUploadModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Documento</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Bill of Lading (BL)</option>
                  <option>Factura Comercial</option>
                  <option>Certificado de Origen</option>
                  <option>Packing List</option>
                  <option>Pedimento</option>
                  <option>Otro</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Archivo</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-[#2F80ED] transition-colors cursor-pointer">
                  <i className="ri-upload-cloud-line text-4xl text-[#6B7280] mb-2"></i>
                  <p className="text-sm text-[#6B7280]">Arrastra archivos aquí o haz clic para seleccionar</p>
                  <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG hasta 10MB</p>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Notas (opcional)</label>
                <textarea rows={2} placeholder="Notas adicionales..." className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"></textarea>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowUploadModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button onClick={handleUploadDocument} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                Subir Documento
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Actualizar Estado */}
      {showStatusModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Actualizar Estado</h2>
              <button onClick={() => setShowStatusModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nuevo Estado</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Documentación</option>
                  <option>En Tránsito</option>
                  <option>En Aduana</option>
                  <option>Revisión</option>
                  <option>Despacho</option>
                  <option>Completada</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Comentario de Bitácora</label>
                <textarea rows={3} placeholder="Describe el cambio de estado..." className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"></textarea>
              </div>
              <div className="flex items-center gap-2">
                <input type="checkbox" id="notify" className="rounded border-gray-300" />
                <label htmlFor="notify" className="text-sm text-gray-700">Notificar al cliente</label>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowStatusModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button onClick={handleUpdateStatus} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                Actualizar Estado
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showSuccessToast && (
        <div className="fixed bottom-6 right-6 bg-[#10B981] text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 z-50">
          <i className="ri-check-circle-line text-xl"></i>
          <span className="font-medium">{toastMessage}</span>
        </div>
      )}
    </Layout>
  );
}
